import { Component, OnInit } from '@angular/core';
import { Dashboard, TransformDetail } from 'src/api/models';
import { DataService,FileService } from 'src/api/services';
import { IconService } from 'src/service/icon.service';
import { IWidgetEditor, WidgetType, ChartWidget } from "src/app/models/dashboard";
import { StorageTablesService } from "src/service/storage-tables.service";
import { ApplicationConfigService } from 'src/service/application-config.service';

@Component({
  selector: "app-open-street-map-widget-editor",
  templateUrl: "./open-street-map-widget-editor.component.html",
  styleUrls: ["./open-street-map-widget-editor.component.css"],
})
export class OpenStreetMapWidgetEditorComponent implements OnInit, IWidgetEditor {
  public widgetType: WidgetType;
  public widget: any;
  public w: any;
  public dashboard: Dashboard;
  
  public transformList: TransformDetail[];
  private colours: string[];

  public showMenu: boolean;

  public pins: any[];

  constructor(public fileService: FileService, 
    public storageTablesService: StorageTablesService, 
    public iconService: IconService, 
    public app: ApplicationConfigService) {
    this.colours = [
      '#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce',
      '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a',
      "#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9",
      "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"
    ];
    this.pins = []
    iconService.getPins(tpins => {
      //this.pins = [];
      for (var key in tpins){
        var pin = tpins[key].options as any;
        pin.key = key;
        this.pins.push(pin);
      }
    });
    
  }

  private newEventType: string;

  ngOnInit() {
    this.w = this.widget;
    
    if (this.w.bandDetailList == null) this.w.bandDetailList = [];
    if (this.w.lineDetailList == null) this.w.lineDetailList = [];
    if (this.w.dataSourceDetailList == null) this.w.dataSourceDetailList = [];

    var i = 0;
    for (let tab of this.w.timeSeriesDetailList) {
      tab.removable = true;
      if (tab.colour == null){
          tab.colour = this.colours[i];
      }
      i++;
    }
    if (this.w.timeSeriesDetailList.length > 0) {
      this.w.timeSeriesDetailList[0].active = true;
    }
  }


  public addLayer() {
    if (this.w.layers == null) {
      this.w.layers = [];
    }
    this.w.layers.push({});
  }

  public removeLayer(layer) {
    var index = this.w.layers.indexOf(layer);
    if (index > -1) {
      this.w.layers.splice(index, 1);
    }
  }

  public addTracker() {
    this.w.timeSeriesDetailList.push({
      uri: " ",
      axis: 0,
      transform: "tracker",
      type: "tracker",
      style: "solid",
      showMarker: false,
      size: 1,
      active: true,
      removable: true,
      colour: this.colours[this.w.timeSeriesDetailList.length],
      transforms: []
    });
  }

  public addGeoJson() {
    this.w.timeSeriesDetailList.push({
      uri: " ",
      axis: 0,
      type: "geojson",
      style: "solid",
      showMarker: false,
      size: 1,
      active: true,
      removable: true,
      colour: this.colours[this.w.timeSeriesDetailList.length],
      transforms: []
    });
  }

  public addHeatmap() {
    this.w.timeSeriesDetailList.push({
      uri: " ",
      axis: 0,
      type: "heatmap",
      style: "solid",
      showMarker: false,
      size: 1,
      weight:100,
      active: true,
      removable: true,
      colour: this.colours[this.w.timeSeriesDetailList.length],
      transforms: [],
      useRssi: false,
    });
  }

  public addFixed() {
    this.w.timeSeriesDetailList.push({
      uri: " ",
      axis: 0,
      transform: null,
      type: "fixed",
      style: "solid",
      showMarker: false,
      size: 1,
      popupHeight: 150,
      active: true,
      removable: true,
      colour: this.colours[this.w.timeSeriesDetailList.length],
      transforms: []
    });
  }

  public removeTimeSeries(timeSeries: any): void {
    var index = this.w.timeSeriesDetailList.indexOf(timeSeries);
    if (index > -1) {
      this.w.timeSeriesDetailList.splice(index, 1);
    }
  }

  updateWidget(tab, selected){
    
  }

  addNewEvent(tab){
    if (tab.events == null){
      tab.events = [];
    }
    if (this.newEventType == 'pin'){
      tab.events.push({
        type:this.newEventType,
        pin: 'blue'
      });
    }
    else if (this.newEventType == 'display'){
      tab.events.push({
        type:this.newEventType,
      });
    }    
    else if (this.newEventType == 'geojson'){
      tab.events.push({
        type:this.newEventType,
      });
    }
  }

  removeEvent(tab, event){
    const index = tab.events.indexOf(event, 0);
    if (index > -1) {
      tab.events.splice(index, 1);
    }
  }

  selectPin(event, pin){
    event.pin = pin.key;
    this.showMenu = false;  
  }

  getPin(key){  
    return this.iconService.pins[key];
  }

  public uploadShapeFile(rule, fileObj) {
    const file = fileObj.item(0);
    
    //todo: read file in and post to API to store as file in Azure Storage
    if(!window.FileReader) return; // Browser is not compatible
    var reader = new FileReader();
    var uploadFile = (d) => {
      /*this.fileService.FileUpload({
        shareType:"dashboard",
        customerId:this.app.customerId,
        fileIdentifier:file.name,
        itemId:this.dashboard.dashboardId.toString(),
        file: d
      }).subscribe(r => {
        rule.geoJsonUri = r;
      }, error => {
        console.error(error);
      });*/
      rule.geoJson = d;
    };

    reader.onloadend = function(evt) {
      if(evt.target.readyState != 2) return;
      if(evt.target.error) {
          alert('Error while reading file');
          return;
      }
      uploadFile(reader.result);
    };
    reader.readAsDataURL(file);
  }
}
